var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _rect, _path43, _path44, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 79,
    viewBox: "0 0 590 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.9658 52.1797H106.825H588.624V76.6763H87.9658V52.1797Z",
    fill: "#6A5DFF",
    stroke: "url(#paint0_linear_3293_34416)",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.77 77.273L97.5178 52.4932",
    stroke: "url(#paint1_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.661 77.273L109.409 52.4932",
    stroke: "url(#paint2_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.561 77.273L121.301 52.4932",
    stroke: "url(#paint3_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.454 77.273L133.202 52.4932",
    stroke: "url(#paint4_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.349 77.273L145.097 52.4932",
    stroke: "url(#paint5_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.249 77.273L156.988 52.4932",
    stroke: "url(#paint6_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.138 77.273L168.886 52.4932",
    stroke: "url(#paint7_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.029 77.273L180.777 52.4932",
    stroke: "url(#paint8_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M195.929 77.273L192.669 52.4932",
    stroke: "url(#paint9_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M207.826 77.273L204.574 52.4932",
    stroke: "url(#paint10_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219.717 77.273L216.465 52.4932",
    stroke: "url(#paint11_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M231.608 77.273L228.356 52.4932",
    stroke: "url(#paint12_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M243.51 77.273L240.258 52.4932",
    stroke: "url(#paint13_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M255.403 77.273L252.151 52.4932",
    stroke: "url(#paint14_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M267.296 77.273L264.044 52.4932",
    stroke: "url(#paint15_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M279.194 77.273L275.942 52.4932",
    stroke: "url(#paint16_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M291.085 77.273L287.833 52.4932",
    stroke: "url(#paint17_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M302.977 77.273L299.725 52.4932",
    stroke: "url(#paint18_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M314.882 77.273L311.63 52.4932",
    stroke: "url(#paint19_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M326.773 77.273L323.521 52.4932",
    stroke: "url(#paint20_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M338.665 77.273L335.413 52.4932",
    stroke: "url(#paint21_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M350.565 77.273L347.304 52.4932",
    stroke: "url(#paint22_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M362.458 77.273L359.206 52.4932",
    stroke: "url(#paint23_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M374.351 77.273L371.099 52.4932",
    stroke: "url(#paint24_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M386.252 77.273L382.992 52.4932",
    stroke: "url(#paint25_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M398.142 77.273L394.89 52.4932",
    stroke: "url(#paint26_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M410.033 77.273L406.781 52.4932",
    stroke: "url(#paint27_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M421.936 77.273L418.676 52.4932",
    stroke: "url(#paint28_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M433.828 77.273L430.576 52.4932",
    stroke: "url(#paint29_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M445.721 77.273L442.469 52.4932",
    stroke: "url(#paint30_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M457.621 77.273L454.36 52.4932",
    stroke: "url(#paint31_linear_3293_34416)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4444 51.0381H16.8956C15.9175 51.0381 14.9565 51.347 14.1671 51.9133L1.96598 60.6394C-0.668154 62.5185 -0.650995 66.4311 1.99172 68.3016L13.5064 76.4099C14.2958 76.9591 15.2396 77.2679 16.2092 77.2679H50.1184",
    fill: "#6A5DFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9201 50.0195H53.3876C50.5904 50.0195 48.3167 52.2847 48.3167 55.0905V73.1776C48.3167 75.9748 50.5819 78.2486 53.3876 78.2486H84.9201C87.7173 78.2486 89.991 75.9834 89.991 73.1776V55.0905C89.991 52.2933 87.7258 50.0195 84.9201 50.0195Z",
    fill: "#6A5DFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4084 50.0195L89.9947 72.1995L53.4084 50.0195Z",
    fill: "#6A5DFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4084 50.0195L89.9947 72.1995",
    stroke: "url(#paint32_radial_3293_34416)",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2852 50L90.1055 61.2487L70.2852 50Z",
    fill: "#6A5DFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2852 50L90.1055 61.2487",
    stroke: "url(#paint33_radial_3293_34416)",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3765 56.3994L84.1818 78.1418L48.3765 56.3994Z",
    fill: "#6A5DFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3765 56.3994L84.1818 78.1418",
    stroke: "url(#paint34_radial_3293_34416)",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3765 68.8896L67.0557 78.2078L48.3765 68.8896Z",
    fill: "#6A5DFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3765 68.8896L67.0557 78.2078",
    stroke: "url(#paint35_radial_3293_34416)",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    width: 49,
    height: 30,
    rx: 15,
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M353.72 19.084C353.136 19.084 352.608 18.984 352.136 18.784C351.672 18.584 351.304 18.296 351.032 17.92C350.76 17.544 350.62 17.1 350.612 16.588H352.412C352.436 16.932 352.556 17.204 352.772 17.404C352.996 17.604 353.3 17.704 353.684 17.704C354.076 17.704 354.384 17.612 354.608 17.428C354.832 17.236 354.944 16.988 354.944 16.684C354.944 16.436 354.868 16.232 354.716 16.072C354.564 15.912 354.372 15.788 354.14 15.7C353.916 15.604 353.604 15.5 353.204 15.388C352.66 15.228 352.216 15.072 351.872 14.92C351.536 14.76 351.244 14.524 350.996 14.212C350.756 13.892 350.636 13.468 350.636 12.94C350.636 12.444 350.76 12.012 351.008 11.644C351.256 11.276 351.604 10.996 352.052 10.804C352.5 10.604 353.012 10.504 353.588 10.504C354.452 10.504 355.152 10.716 355.688 11.14C356.232 11.556 356.532 12.14 356.588 12.892H354.74C354.724 12.604 354.6 12.368 354.368 12.184C354.144 11.992 353.844 11.896 353.468 11.896C353.14 11.896 352.876 11.98 352.676 12.148C352.484 12.316 352.388 12.56 352.388 12.88C352.388 13.104 352.46 13.292 352.604 13.444C352.756 13.588 352.94 13.708 353.156 13.804C353.38 13.892 353.692 13.996 354.092 14.116C354.636 14.276 355.08 14.436 355.424 14.596C355.768 14.756 356.064 14.996 356.312 15.316C356.56 15.636 356.684 16.056 356.684 16.576C356.684 17.024 356.568 17.44 356.336 17.824C356.104 18.208 355.764 18.516 355.316 18.748C354.868 18.972 354.336 19.084 353.72 19.084ZM357.708 15.676C357.708 14.988 357.849 14.388 358.129 13.876C358.409 13.356 358.797 12.956 359.293 12.676C359.789 12.388 360.357 12.244 360.997 12.244C361.821 12.244 362.501 12.452 363.037 12.868C363.581 13.276 363.945 13.852 364.129 14.596H362.317C362.221 14.308 362.057 14.084 361.825 13.924C361.601 13.756 361.321 13.672 360.985 13.672C360.505 13.672 360.125 13.848 359.845 14.2C359.565 14.544 359.425 15.036 359.425 15.676C359.425 16.308 359.565 16.8 359.845 17.152C360.125 17.496 360.505 17.668 360.985 17.668C361.665 17.668 362.109 17.364 362.317 16.756H364.129C363.945 17.476 363.581 18.048 363.037 18.472C362.493 18.896 361.813 19.108 360.997 19.108C360.357 19.108 359.789 18.968 359.293 18.688C358.797 18.4 358.409 18 358.129 17.488C357.849 16.968 357.708 16.364 357.708 15.676ZM367.039 13.384C367.255 13.032 367.535 12.756 367.879 12.556C368.231 12.356 368.631 12.256 369.079 12.256V14.02H368.635C368.107 14.02 367.707 14.144 367.435 14.392C367.171 14.64 367.039 15.072 367.039 15.688V19H365.359V12.352H367.039V13.384ZM376.391 15.532C376.391 15.772 376.375 15.988 376.343 16.18H371.483C371.523 16.66 371.691 17.036 371.987 17.308C372.283 17.58 372.647 17.716 373.079 17.716C373.703 17.716 374.147 17.448 374.411 16.912H376.223C376.031 17.552 375.663 18.08 375.119 18.496C374.575 18.904 373.907 19.108 373.115 19.108C372.475 19.108 371.899 18.968 371.387 18.688C370.883 18.4 370.487 17.996 370.199 17.476C369.919 16.956 369.779 16.356 369.779 15.676C369.779 14.988 369.919 14.384 370.199 13.864C370.479 13.344 370.871 12.944 371.375 12.664C371.879 12.384 372.459 12.244 373.115 12.244C373.747 12.244 374.311 12.38 374.807 12.652C375.311 12.924 375.699 13.312 375.971 13.816C376.251 14.312 376.391 14.884 376.391 15.532ZM374.651 15.052C374.643 14.62 374.487 14.276 374.183 14.02C373.879 13.756 373.507 13.624 373.067 13.624C372.651 13.624 372.299 13.752 372.011 14.008C371.731 14.256 371.559 14.604 371.495 15.052H374.651ZM386.833 12.352L384.889 19H383.077L381.865 14.356L380.653 19H378.829L376.873 12.352H378.577L379.753 17.416L381.025 12.352H382.801L384.049 17.404L385.225 12.352H386.833Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M379.5 35L376.469 29.75L382.531 29.75L379.5 35Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3293_34416",
    x1: 337.806,
    y1: 45.2812,
    x2: 338.784,
    y2: 83.5748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3293_34416",
    x1: 98.822,
    y1: 52.21,
    x2: 99.4655,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3293_34416",
    x1: 110.713,
    y1: 52.21,
    x2: 111.365,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3293_34416",
    x1: 122.605,
    y1: 52.21,
    x2: 123.257,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3293_34416",
    x1: 134.497,
    y1: 52.21,
    x2: 135.149,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3293_34416",
    x1: 146.401,
    y1: 52.21,
    x2: 147.053,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3293_34416",
    x1: 158.292,
    y1: 52.21,
    x2: 158.945,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3293_34416",
    x1: 170.182,
    y1: 52.21,
    x2: 170.834,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3293_34416",
    x1: 182.082,
    y1: 52.21,
    x2: 182.725,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3293_34416",
    x1: 193.973,
    y1: 52.21,
    x2: 194.625,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3293_34416",
    x1: 205.87,
    y1: 52.21,
    x2: 206.522,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3293_34416",
    x1: 217.77,
    y1: 52.21,
    x2: 218.413,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3293_34416",
    x1: 229.661,
    y1: 52.21,
    x2: 230.313,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3293_34416",
    x1: 241.553,
    y1: 52.21,
    x2: 242.206,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3293_34416",
    x1: 253.455,
    y1: 52.21,
    x2: 254.099,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3293_34416",
    x1: 265.348,
    y1: 52.21,
    x2: 266,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3293_34416",
    x1: 277.238,
    y1: 52.21,
    x2: 277.89,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3293_34416",
    x1: 289.138,
    y1: 52.21,
    x2: 289.781,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3293_34416",
    x1: 301.029,
    y1: 52.21,
    x2: 301.681,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3293_34416",
    x1: 312.926,
    y1: 52.21,
    x2: 313.578,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3293_34416",
    x1: 324.826,
    y1: 52.21,
    x2: 325.469,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3293_34416",
    x1: 336.717,
    y1: 52.21,
    x2: 337.369,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3293_34416",
    x1: 348.608,
    y1: 52.21,
    x2: 349.26,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3293_34416",
    x1: 360.51,
    y1: 52.21,
    x2: 361.154,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3293_34416",
    x1: 372.403,
    y1: 52.21,
    x2: 373.055,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3293_34416",
    x1: 384.296,
    y1: 52.21,
    x2: 384.948,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3293_34416",
    x1: 396.185,
    y1: 52.21,
    x2: 396.837,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3293_34416",
    x1: 408.085,
    y1: 52.21,
    x2: 408.737,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3293_34416",
    x1: 419.98,
    y1: 52.21,
    x2: 420.632,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3293_34416",
    x1: 431.872,
    y1: 52.21,
    x2: 432.524,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3293_34416",
    x1: 443.773,
    y1: 52.21,
    x2: 444.417,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3293_34416",
    x1: 455.665,
    y1: 52.21,
    x2: 456.317,
    y2: 77.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_3293_34416",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.693 61.1052) scale(15.393 15.393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_3293_34416",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.1953 55.6201) scale(8.32284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_3293_34416",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.2749 67.2706) scale(15.0841 15.0841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_3293_34416",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7118 73.5487) scale(7.62786 7.62786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrew);
export default __webpack_public_path__ + "static/media/Screw.e9ed30af6bd48eb8ec1a36750f7b99e1.svg";
export { ForwardRef as ReactComponent };